import { StatutsTache } from '../enums/statuts-tache.enum';
import { StoreKeys } from '../enums/store-keys.enum';
import { mesTachesService } from '../services/api';
import { huitabSettings } from './settings-loader';
import { StoreManager } from './store-manager';

/**
 * Tache Manager
 * @constructor
 * @public
 */
class HuitabTacheManager {
  /**
   * ID d'intervalle qui identifie de manière unique l'intervalle
   */
  intervalId;

  /**
   * Initialise une instance de type {@type HuitabTacheManager}
   */
  constructor() {
    StoreManager.subscribe(StoreKeys.USER_INFO, this._startInterval.bind(this));
  }

  /**
   * Relancer le téléchargement de la tache
   * @public
   * @param idTache {string}
   * @return {Promise<void|*>}
   */
  relancer(idTache) {
    return new Promise((resolve, reject) => {
      const tacheIndex = StoreManager.taches.liste.findIndex((tache) => tache.id === idTache);
      if (tacheIndex === -1) {
        reject(null);
      }

      const tache = StoreManager.taches.liste[tacheIndex];
      const tacheClone = { ...tache };

      tache.statut = StatutsTache.EN_ATTENTE;
      tache.version = tache.version + 1;
      this.ajouter([tache]);

      mesTachesService
        .modifierTache(StoreManager.cnAlex, tache)
        .then((tache) => {
          resolve();
        })
        .catch((err) => {
          this._rollBack(tacheClone);
          reject(err);
        });
    });
  }

  /**
   * Ajoute les taches dans le store et le local storage
   * @public
   * @param {TacheDto[]} taches plusieurs tachesDTO
   */
  ajouter(taches) {
    StoreManager.tachesTemp = this._mergerTaches(taches, StoreManager.tachesTemp);
    const newTaches = this._mergerTaches(taches, StoreManager.taches.liste);
    StoreManager.taches = {
      statutOk: StoreManager.taches.statutOk,
      liste: newTaches,
    };
  }

  /**
   * Remplace la tache dans taches et tachesTemp du store
   * @param tacheRollback {TacheDto} La tache
   * @private
   */
  _rollBack(tacheRollback) {
    const tacheTempIndex = StoreManager.tachesTemp.findIndex((tache) => tache.id === tacheRollback.id);
    if (tacheTempIndex !== -1) {
      StoreManager.tachesTemp[tacheTempIndex] = tacheRollback;
      StoreManager.tachesTemp = StoreManager.tachesTemp;
    }

    const tacheIndex = StoreManager.taches.liste.findIndex((tache) => tache.id === tacheRollback.id);
    if (tacheIndex !== -1) {
      StoreManager.taches.liste[tacheIndex] = tacheRollback;
      StoreManager.taches = {
        statutOk: StoreManager.taches.statutOk,
        liste: StoreManager.taches.liste,
      };
    }
  }

  /**
   * Merge la nouvelle tache avec la liste de taches.
   * On ajoute la nouvelle tache si elle n'est pas déjà dans la liste.
   * Sinon on remplace la tache existante par la nouvelle si sa version est plus récente.
   * @private
   * @param {TacheDto[]} tachesToAdd Les taches à merger
   * @param {TacheDto[]} taches La liste de taches
   *
   * @return {TacheDto[]} taches La liste de taches mis à jour
   */
  _mergerTaches(tachesToAdd, taches) {
    tachesToAdd.forEach((tache) => {
      let indexTacheExist = taches.findIndex((el) => tache.id === el.id);

      if (indexTacheExist === -1) {
        taches.push(tache);
      } else {
        if (tache.version > taches[indexTacheExist].version) {
          taches[indexTacheExist] = tache;
        }
      }
    });
    return taches;
  }

  /**
   * Synchronise la liste des taches récupérées via api mes-taches
   * avec la liste des taches temporaires
   *
   * @public
   * @param {TacheDto[]} tachesTemp La liste de taches temporaires
   * @param {TacheDto[]} taches La liste de taches
   *
   * @return {TacheDto[]} taches La liste de taches mis à jour
   */
  synchroTaches(tachesTemp, taches) {
    if (!tachesTemp) {
      return taches;
    }

    return this._mergerTaches(tachesTemp, taches);
  }

  /**
   * Lancer la récupération des taches
   * @public
   */
  _startInterval() {
    this._fetchTaches();
    this.intervalId = setInterval(this._fetchTaches.bind(this), huitabSettings.tache_refresh_interval);

    document.onvisibilitychange = () => {
      if (document.visibilityState === 'hidden') {
        clearInterval(this.intervalId);
        this.intervalId = undefined;
      } else if (!this.intervalId) {
        this.intervalId = setInterval(this._fetchTaches.bind(this), huitabSettings.tache_refresh_interval);
      }
    };
  }

  /**
   * Récupère la liste des taches depuis l'api mes-taches client
   * à intervalles réguliers (delai = tache_refresh_interval)
   * @private
   */
  _fetchTaches() {
    mesTachesService
      .getListeTaches(StoreManager.cnAlex)
      .then((taches) => {
        const tachesSynchronized = this.synchroTaches(StoreManager.tachesTemp, taches);
        StoreManager.taches = {
          statutOk: true,
          liste: tachesSynchronized,
        };
      })
      .catch((e) => {
        StoreManager.taches = { statutOk: false, liste: [] };
      });
  }
}

const TacheManager = new HuitabTacheManager();
export { TacheManager };
